export default {
  language_selector: {
    label: 'Valitse kieli',
  },
  nav_items: {
    home: 'Koti',
    menu: 'Valikko',
    locations: 'Sijainnit',
    store_info: 'Tietoa liikkeestä',
    rewards: 'Edut',
  },
};
